module.exports = __webpack_public_path__ + "static/media/delete.f19987d7.svg";